// Hero section component
import { Logo } from './Logo';
import { trackExternalLink } from '../utils/analytics';

export function Hero() {
  return (
    <section className="relative z-10 mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 lg:py-24 pointer-events-none">
      <div className="flex flex-col md:flex-row items-center md:items-start gap-6 max-w-4xl mx-auto md:mx-0 pointer-events-auto">
        <Logo className="w-16 h-16 md:w-20 lg:w-24 md:h-20 lg:h-24 flex-shrink-0 md:mt-2" />
        <div className="flex-1 text-center md:text-left">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight">
            Off-Grid Mesh Communication
            <span className="block text-cyan-400 mt-2">For Everyone</span>
          </h1>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-zinc-300">
            Explore mesh networking powered by <a href="https://meshtastic.org/" className="text-cyan-400 hover:text-cyan-300 underline pointer-events-auto" target="_blank" rel="noopener noreferrer">Meshtastic</a>—an open source, 
            off-grid messaging platform that runs on affordable, low-power devices. 
            No phone, internet, or subscription required.
          </p>
          <p className="mt-3 text-sm md:text-base text-zinc-400">
            Decentralized • Privacy-First • 100% Open Source
          </p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row sm:flex-wrap gap-3 items-stretch sm:items-center justify-center md:justify-start">
            <a
              href="#join"
              className="rounded-2xl px-4 md:px-5 py-2.5 md:py-3 bg-cyan-400 text-zinc-900 font-semibold hover:bg-cyan-300 transition pointer-events-auto text-sm md:text-base text-center"
            >
              Find a Community
            </a>
            <a
              href="#about"
              className="rounded-2xl px-4 md:px-5 py-2.5 md:py-3 bg-zinc-800 text-white font-medium hover:bg-zinc-700 transition pointer-events-auto text-sm md:text-base text-center"
            >
              Learn More
            </a>
            <a
              href="https://meshtastic.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-2xl px-4 md:px-5 py-2.5 md:py-3 border border-zinc-700 text-zinc-300 font-medium hover:border-cyan-400 hover:text-cyan-400 transition pointer-events-auto text-sm md:text-base text-center"
              onClick={() => trackExternalLink('meshtastic.org', 'hero_cta')}
            >
              About Meshtastic
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
